const EXPECTED_CLIENT_ERROR_MESSAGES = new Set([
  'Bad Request',
  'Unauthorized',
  'Forbidden',
  'Not Found',
  'Conflict',
  'Unprocessable Entity',
]);

export const getHttpStatus = error => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  if (typeof error.status === 'number') {
    return error.status;
  }

  if (typeof error.statusCode === 'number') {
    return error.statusCode;
  }

  if (error.response && typeof error.response.status === 'number') {
    return error.response.status;
  }

  return undefined;
};

/**
 * Expected/handled HTTP client failures (4xx) should not be reported to Sentry.
 * fwp-fetch often surfaces status text as Error.message when status is unavailable.
 */
export const isExpectedClientHttpError = error => {
  const status = getHttpStatus(error);

  if (typeof status === 'number') {
    return status >= 400 && status < 500;
  }

  return EXPECTED_CLIENT_ERROR_MESSAGES.has(error?.message);
};
